// TODO: Remove this file. Instantiate every service in its own file.

import {BlinkPaymentProcessor} from "./BlinkPaymentProcessor";

export const blinkPaymentProcessor = new BlinkPaymentProcessor();
export {authService} from "./services/AuthService";
export {userService} from "./services/UserService";
